




























import { Component, Vue, Provide, Watch } from 'vue-property-decorator';
import { Role } from '@/dtos/role';
import { User } from '@/dtos/user';
import { projectAddUser, projectUpdateUser } from '@/apis/super.api';
import { Action, State } from 'vuex-class';
import { Project } from '@/dtos/project';
import { mounted } from '../../../services/VueTimmer';



@Component
export default class UpdateUserPage extends Vue {

  roles = [ { text: 'ADMIN', value: 'ADMIN' }, 
            { text: 'OPERATOR', value: 'OPERATOR' },
            { text: 'MONITOR', value: 'MONITOR' } ]

  @Provide()
  form: User = {
    role: null,
    email: '',
  };

  @State(state => state.admin.projects)
  projects! : {[k:string]:Project}

  get projectId(){
    return this.$route.params.project_id
  }

  get userEmail(): string {
    return this.$route.params.user_id
  }

  get projectData() : Project{
    return this.projects[this.projectId]
  }
  
  get projectUsers() : User[]{
    return Object.values(this.projectData && this.projectData.users || {})
  }

  get user(): User {
    return this.projectData && this.projectData.users && this.projectData.users[this.userEmail]
  }

  @Provide()
  loadings = false

  onSubmit(evt) {
    this.loadings = true;
    projectUpdateUser(
      this.form,
      this.projectId
    ).then(() => {
        this.$swal({
          type: 'success',
          title: 'Success!',
        }).then(() => {
          this.$router.push({ name: 'project_user', params: { project_id: this.projectId }});
        });
      })
      .catch((error) => {
        this.$popupError(error)
        this.form = this.user || this.form
      })
      .finally(() => {
        this.loadings = false;
      });
  }

  @mounted
  @Watch("user")
  onUserChange(){
    this.form = this.user || this.form
  }
}
